<div>
<div class="pure-menu pure-menu-horizontal">
  <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">View/Configure Previous Update Requests</a>
</div>
<div class="container">
  <!-- Fetch Previous Requests Form-->
  <form [formGroup]="previousRequestsForm" [hidden]="loading" class="pure-form pure-form-stacked" (ngSubmit)="render()">

    <!-- Select option for From Country Code Options -->
    <div class="pure-control-group">
      <label for="fromCountryCodeId">From Country Code <app-popover [message]="help_messages.from_country_code"></app-popover></label>
      <select id="fromCountryCodeId" class="pure-input-2-3"
              formControlName="fromCountryCode" #fromCountryCode (change)="onFromCountryCodeChange(fromCountryCode.value)">
        <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                [value]="_fromCountryCode">
          {{ _fromCountryCode }}
        </option>
      </select>
    </div>

    <div class="pure-control-group">
      <label for="businessUseCase">Business Use Case  <app-popover [message]="help_messages.business_unit"></app-popover></label>
      <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase" #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
        <ng-template ngFor let-item [ngForOf]="getItems">
          <optgroup label="{{item.name}}">
            <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
              {{usecase.text}}
            </option>
          </optgroup>
        </ng-template>
      </select>
    </div>

    <!-- Read only text for displaying onboarded component key placeholder-->
    <label for="componentKeyPlaceholderId">Level Of Data  <app-popover [message]="help_messages.level_of_data"></app-popover></label>
    <input id="componentKeyPlaceholderId" class="pure-input-2-3" type="text"
           formControlName="componentKeyPlaceholder" readonly/>

    <!-- Dynamic entries for Component Key Place holder parts -->
    <form [formGroup]="previousRequestsForm.get('componentKeyValue')">
      <div *ngFor="let field of currentComponentKeyPlaceholder;let i = index">
        <label for="{{'componentKeyValue'+i}}">{{field}}</label>
        <select type="text" [formControlName]="field" class="pure-input-2-3" id="{{'componentKeyValue'+i}}">
          <option *ngFor="let option of dropDownOptions[field]" [value]="option">
            {{option}}
          </option>
        </select>
      </div>
    </form>

    <!-- Select option for Transit Time Type-->
    <label for="transitTimeTypeId">Select Transit Time Type <app-popover [message]="help_messages.transit_time_type"></app-popover></label>
    <select formControlName="transitTimeType" id="transitTimeTypeId" class="pure-input-2-3">
      <option *ngFor=" let _transitTime of transitTimeOptions; let i = index " [value]="_transitTime">
        {{ _transitTime }}
      </option>
    </select>

    <!-- Number of days of past numberOfDaysOfHistory -->
    <div class="pure-control-group">
      <label for="numberOfDaysOfHistoryId">Number Of Days Of History <app-popover [message]="help_messages.history"></app-popover></label>
      <select id="numberOfDaysOfHistoryId" class="pure-input-2-3"
              formControlName="numberOfDaysOfHistory">
        <option *ngFor="let _numberOfDaysOfHistory of numberOfDaysOfHistoryOptions; let i = index"
                [value]="_numberOfDaysOfHistory">
          {{ _numberOfDaysOfHistory }} days
        </option>
      </select>
    </div>

    <!-- Get data Buttons-->
    <div>
      <button class="pure-button pure-button-primary button-large" type="submit"
              [disabled]="previousRequestsForm.invalid">
        Submit
      </button>
    </div>
  </form>

  <div *ngIf="previousRequests.length != 0 && !loading && hasPermission">
    <table class="pure-table pure-table-horizontal">
      <thead>
      <tr>
        <th>Business Use Case</th>
        <th>From Country Code</th>
        <th>Level Of Data</th>
        <th>Transit Time Type</th>
        <th>File Version</th>
        <th>Request Status</th>
        <th>Request Type</th>
        <th>Approval Type</th>
        <th>Created By</th>
        <th>Creation Time(UTC)</th>
        <th>Last Updated By</th>
        <th>Last Updated Time(UTC)</th>
        <th>Approved/Rejected By</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let _row of previousRequests">
        <td>
          {{_row.businessUseCase != null ? _row.businessUseCase : "N/A"}}
        </td>
        <td>
          {{_row.fromCountryCode != null ? _row.fromCountryCode : "N/A"}}
        </td>
        <td>
          {{_row.componentKeyValue != null ? _row.componentKeyValue : "N/A"}}
        </td>
        <td>
          {{ _row.transitTimeType != null ? _row.transitTimeType : "N/A"}}
        </td>
        <td>
          {{ _row.timestamp != null ? _row.timestamp  : "N/A"}}
        </td>
        <td>
          {{_row.requestStatus != null ? _row.requestStatus : "N/A"}}
        </td>
        <td>
          {{_row.requestType != null ? _row.requestType : "N/A"}}
        </td>
        <td>
          {{_row.approvalType != null ? _row.approvalType : "N/A"}}
        </td>
        <td>
          {{ _row.createdBy != null ?  _row.createdBy: "N/A"}}
        </td>
        <td>
          {{ _row.timestamp != null ? this.commonUtils.convertToDate(_row.timestamp) : "N/A"}}
        </td>
        <td>
          {{ _row.lastUpdatedBy != null ?  _row.lastUpdatedBy: "N/A"}}
        </td>
        <td>
          {{ _row.lastUpdatedTime != null ? this.commonUtils.convertToDate(_row.lastUpdatedTime) : "N/A"}}
        </td>
        <td>
          {{ _row.approvedBy != null ?  _row.approvedBy: "N/A"}}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <!-- Display message when the table is empty -->
  <div *ngIf="previousRequests.length == 0 && !loading && !firstLoad && hasPermission">
    <h2>There are no previous requests.</h2>
  </div>

  <app-loader [loading]="loading" [size]="'small'"></app-loader>
</div>

</div>
